import { notificationApi } from "@/getinfo-api/index";

export interface NotificationsListParams {
  userId: string;
  companyId?: string;
  read?: boolean;
  readAtMin?: Date;
  readAtMax?: Date;
  createdAtMin?: Date;
  createdAtMax?: Date;
  updatedAtMin?: Date;
  updatedAtMax?: Date;
  offset?: number;
  limit?: number;
  sort?: "readAt" | "createdAt" | "updatedAt";
  order?: "ASC" | "DESC";
  options?: any;
}

export const list = (params: NotificationsListParams) => {
  return notificationApi.Notification.listNotification(
    params.userId,
    params.companyId,
    params.read,
    params.readAtMin,
    params.readAtMax,
    params.createdAtMin,
    params.createdAtMax,
    params.updatedAtMin,
    params.updatedAtMax,
    params.offset,
    params.limit,
    params.sort,
    params.order,
    params.options
  );
};
